export default __webpack_public_path__ + "static/cloud-native_01-af4f8e6341129a747416cdf19b95e7f1.png";